import { Component, Input } from '@angular/core';

@Component({
  selector: 'brt-business-avatar',
  standalone: true,
  imports: [],
  templateUrl: './business-avatar.component.html',
  styleUrl: './business-avatar.component.css'
})
export class BusinessAvatarComponent {
  @Input({required: true}) businessId: string;
  @Input({required: true}) profile: any;

}
